import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Strain type pill (e.g. "Indica", "Sativa", "Hybrid"). Renders nothing when strainType is absent. */
export function CardStrainType(): JSX.Element | null {
  const { strainType } = useCardContext();

  if (!strainType) {
    return null;
  }

  return <Pill data-testid='card-strain'>{strainType}</Pill>;
}

const Pill = styled.div`
  background: #e3e7e9;
  border-radius: 12px;
  color: #2c3236;
  display: inline-block;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 8px;
`;
